export const LOCALES = {
    SPANISH: "es",
    ENGLISH: "en",
}